import React from 'react';

import type { Text } from '@zillow/constellation';
import { AdornedInput, Adornment, FormField, Input, Label } from '@zillow/constellation';

import type { Section } from '../../../models';
import { SECURITY_DEPOSIT } from '../../../constants';
import type { HTMLElementEvent } from '../../../models/Types';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function InterestRate({ section, setSectionValues }: Props) {
  function onInterestRateChange(event: HTMLElementEvent<typeof Text>): void {
    const { value } = event.currentTarget;

    setSectionValues({
      [SECURITY_DEPOSIT.FIELD_NAME.INTEREST_RATE]: value,
    });
  }

  return (
    <FormField
      label={<Label size="lg">What is the security deposit interest rate?</Label>}
      control={
        <AdornedInput
          rightAdornment={<Adornment>%</Adornment>}
          input={
            <Input
              value={section.getFieldValue(SECURITY_DEPOSIT.FIELD_NAME.INTEREST_RATE)}
              onChange={onInterestRateChange}
              type="number"
            />
          }
        />
      }
    />
  );
}

InterestRate.description =
  'Asks what the security deposit interest rate is depending on if they chose option.  Optional screen';

export default InterestRate;
